export default "__VITE_ASSET__BwO52ibS__"